import { ApiSchemaTaskSettings } from "../../models/api";
import { AxiosAuth } from "../axios";
import {
  useExtendedApiAccess,
  CreateAccessObject,
} from "./useExtendedApiAccess";
import { AppRouteApi } from "../../config/appRoute";
import { SWRResponse } from "swr";
import { ApiResponseContainer } from "../../models/api/responseContainer";
import {
  showErrorToast,
  showSuccessToast,
} from "../../components/toast.component";

const CacheIds = {
  ById: AppRouteApi.TaskSettings.ById(""),
};

function useApiTaskSettingsById(
  CompanyId: string
): SWRResponse<ApiSchemaTaskSettings | undefined, Error> {
  const response = useExtendedApiAccess<ApiSchemaTaskSettings>(
    CacheIds.ById,
    () => AxiosAuth.get(AppRouteApi.TaskSettings.ById(CompanyId))
  );

  return response;
}

async function AddTaskSettings(
  taskSettings: Partial<ApiSchemaTaskSettings>
): Promise<ApiResponseContainer<ApiSchemaTaskSettings>> {
  try {
    const response = await AxiosAuth.post<
      ApiResponseContainer<ApiSchemaTaskSettings>
    >(AppRouteApi.TaskSettings.Root(), taskSettings);
    if (response.data.isSuccess) showSuccessToast("Settings Updated!");
    return response.data;
  } catch (e: any) {
    return showErrorToast({ isSuccess: false, ...JSON.parse(e.message).data });
  }
}

async function UpdateTaskSettings(
  taskSettings: Partial<ApiSchemaTaskSettings>
): Promise<ApiResponseContainer<ApiSchemaTaskSettings>> {
  try {
    const response = await AxiosAuth.put<
      ApiResponseContainer<ApiSchemaTaskSettings>
    >(AppRouteApi.TaskSettings.Root(), taskSettings);
    if (response.data.isSuccess) showSuccessToast("Settings Updated!");
    return response.data;
  } catch (e: any) {
    return showErrorToast({ isSuccess: false, ...JSON.parse(e.message).data });
  }
}

const AccessObject = {
  ById: CreateAccessObject<
    ApiSchemaTaskSettings,
    typeof useApiTaskSettingsById
  >(CacheIds.ById, useApiTaskSettingsById),
};

export const ApiTaskSettings = {
  ById: AccessObject.ById,
  AddTaskSettings,
  UpdateTaskSettings,
};
